/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <k.pawlak@giap.pl>, July 2026
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import { isMobileView, isTabletView, renderHelpDesc, isSuperAdminRole } from '../../components/utils/utils';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import loadingData from './loading';
import { btnStyle, bodyStyle, redirectToSummary } from './constants';
import { trackEvent } from '../../lib/utils';
import ButtonsPanel from './utils/ButtonsPanel';
import waiting from '../paymentStatus/waiting-wheel-300x300.gif';

import v from './validators';

const graveOptions = [
  {
    state: 'graveType',
    value: 'Ziemny',
    label: 'Ziemny',
  },
  {
    state: 'graveType',
    value: 'Murowany',
    label: 'Murowany',
  },
  {
    state: 'graveType',
    value: 'Inny',
    label: 'Inny',
  },
]

const infoDict = {
  address: {
    label: 'Adres grobu',
    editable: true,
    type: 'textarea'
  },
  graveType: {
    label: 'Rodzaj grobu',
    editable: true,
    type: 'Select',
    options: graveOptions
  },
  graveTypeOther: {
    label: 'Inny rodzaj grobu (jeżeli wybrano "Inny")',
    editable: true,
    type: 'textarea'
  },
  lastPaymentDate: {
    label: 'Data uiszczenia ostatniej opłaty za grób/miejsce',
    editable: true,
  },
  paymentValidUntil: {
    label: 'Grób opłacony do',
    editable: true,
  },
};

const burialDict = {
  firstName: {
    label: 'Imię',
    editable: true,
  },
  lastName: {
    label: 'Nazwisko',
    editable: true,
  },
  dateOfBirth: {
    label: 'Data urodzenia',
    editable: true,
  },
  dateOfDeath: {
    label: 'Data śmierci',
    editable: true,
  },
};

class DeklaracjaGrobu extends React.Component {
  state = {
    info: {
      address: null,
      graveType: null,
      graveTypeOther: null,
      lastPaymentDate: null,
      paymentValidUntil: null
    },
    listOfBurials: [
      {
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        dateOfDeath: '',
      }
    ],

    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    burialErrors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    attachments: null,
    eserviceDistrict: null,
    loading: false,
    isMounted: false,
  };

  validators = {
    address: [v.NotNull],
    graveType: [v.NotSelected],
    graveTypeOther: [],
    lastPaymentDate: [v.NotNull, v.CheckDate],
    paymentValidUntil: [v.NotNull, v.CheckDate],
    firstName : [v.NotNull],
    lastName : [v.NotNull],
    dateOfBirth : [v.NotNull, v.CheckDate],
    dateOfDeath : [v.NotNull, v.CheckDate],
  };

  async componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
          isMounted: true,
        });
      });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.info.graveType !== this.state.info.graveType) {
      this.updateValidators();
    }
  }

  updateValidators = () => {
    if (this.state.info.graveType === 'Inny') {
      this.validators.graveTypeOther = [v.NotNull];
    }
    else {
      this.validators.graveTypeOther = [];
    }
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  addBurial = () => {
    this.setState({
      listOfBurials: [...this.state.listOfBurials, {
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        dateOfDeath: '',
      }],
    });
  }

  removeBurial = (i, state) => {
    const list = [...this.state[state]];

    if (i > -1) {
      list.splice(i, 1);
    }

    this.setState({
      [state]: list
      }
    );
  }

  onChangeBurial = (e, state, index) => {
    const name = e.target.name;              // nazwa pola z burialDict
    const arr = [...this.state[state]];      // kopia tablicy
    const updatedItem = { ...arr[index] };  // kopia obiektu

    updatedItem[name] = e.target.value;
    arr[index] = updatedItem;

    this.setState(
      { [state]: arr },
      () => this.validateBurials(state, name, index)
    );
  };

  validateBurials = (group = null, field = null, index = null) => {
    let newState = null;
    if (field) {
      const checks = this.validateBurialField(group, field, index);
      newState = {
          ...this.state.burialErrors,
          [`${field}${index}`]: checks,
      };
    } else {
      let errors = {};
      const grupy = ['listOfBurials'];
      for (const g of grupy) {
        const err = this.validateListGroups(g);
        errors = { ...errors, ...err };
      }
      newState = { ...errors };
    }

    if (newState) {
      this.setState({ burialErrors: newState });
    }
  };

  validateBurialField = (group, field, index) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][index][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateListGroups = (group) => {
    const errors = {};
    let idx = 0;
    if (this.state[group]) {
      for (const obj of this.state[group]) {
        for (const i in Object.keys(obj)) {
          const field = Object.keys(obj)[i];
          const checks = this.validateBurialField(group, field, idx);
          errors[`${field}${idx}`] = checks;
        }
        idx += 1;
      }
    }
    return errors;
  };

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  hasErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    for (const key of Object.keys(this.state.burialErrors)) {
      if (this.state.burialErrors[key].length > 0) return true;
    }
    return false;
  };

  postValidation = async () => {

    await this.validateBurials();
  
    const hasFieldErrors = this.hasErrors();
    if (hasFieldErrors) {
      return this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
    }

    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          info: { ...this.state.info, listOfBurials: this.state.listOfBurials },
          user: {
            ...this.props.serviceInfo.user,
          },
          selectedParcels: this.state.selectedParcels,
          shortName: this.props.serviceInfo.eservice.shortName,
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () => {
              trackEvent({
                category: 'application',
                action: 'click',
                name: this.props.serviceInfo.eservice.title,
              });
              redirectToSummary(resp.jobId);
            }
          );
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);

    if (!this.state.isMounted) {
      return (
        <GrayPanel
          title="Trwa ładowanie zawartości..."
          bodyStyle={bodyStyle}
        >
          <img alt="Loader" src={waiting} />
        </GrayPanel>
      );
    }

    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <DecisionContainer
          title={'1. Informacje o grobie'}
          data={this.state.info}
          errors={this.state.errors}
          formDict={infoDict}
          onChange={e => this.onChange(e, 'info')}
          onChangeSelect={e => this.onChangeSelect(e, 'info')}
        />

        <GrayPanel
          title={'2. Dane osób pochowanych w grobie'}
        >
          {this.state.listOfBurials.map((burial, index) => (
            <DecisionContainer
              key={index}
              title={`Osoba pochowana ${index + 1}`}
              data={burial}
              errors={{
                firstName: this.state.burialErrors[`firstName${index}`] || [],
                lastName: this.state.burialErrors[`lastName${index}`] || [],
                dateOfBirth: this.state.burialErrors[`dateOfBirth${index}`] || [],
                dateOfDeath: this.state.burialErrors[`dateOfDeath${index}`] || [],
              }}
              formDict={burialDict}
              onChange={e => this.onChangeBurial(e, 'listOfBurials', index)}
              children={this.state.listOfBurials.length > 1 && (
                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => this.removeBurial(index, 'listOfBurials')}
                  >
                    Usuń osobę pochowaną
                  </button>
                </div>
              )}
            ></DecisionContainer>
          ))}
          <div style={{ textAlign: 'center', marginTop: '10px' }}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.addBurial}
            >
              Dodaj osobę pochowaną
            </button>
          </div>
        </GrayPanel>
        
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <ButtonsPanel
          prefix={this.props.prefix}
          shortName={this.props.serviceInfo.eservice.shortName}
          serviceTitle={this.props.serviceInfo.eservice.title}
          onSave={() => this.setState({ loading: true }, () => this.startService())}
          onCancel={history.goBack}
        />
      </div>
    );
  }
}

DeklaracjaGrobu.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(DeklaracjaGrobu),
);



// WEBPACK FOOTER //
// src/routes/eservices/DeklaracjaGrobu.js